import { render, staticRenderFns } from "./ChangeInform.vue?vue&type=template&id=0629d820&scoped=true&"
import script from "./ChangeInform.vue?vue&type=script&lang=js&"
export * from "./ChangeInform.vue?vue&type=script&lang=js&"
import style0 from "./ChangeInform.vue?vue&type=style&index=0&id=0629d820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629d820",
  null
  
)

export default component.exports